import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromStaticDataReducer from '../reducers';
import * as staticDataCountriesReducer from '../reducers/index';
import * as staticDataReducer from '../static-data.reducer';

//#region Static Data ROOT STATE
export const getAuthState = createFeatureSelector<staticDataReducer.State, staticDataReducer.StaticDataState>(
  staticDataReducer.staticDataFeatureKey
);
//#endregion

export const getStaticDataPepRisksState = createSelector(
  getAuthState,
  state => state[fromStaticDataReducer.fromStaticDataPepRisksReducer.staticDataPepRisksFeatureKey]
);

export const getStaticDataPepRisksFailure = createSelector(
  getStaticDataPepRisksState,
  staticDataCountriesReducer.fromStaticDataPepRisksReducer.getPepRisksError
);

export const getStaticDataPepRisksResponse = createSelector(
  getStaticDataPepRisksState,
  staticDataCountriesReducer.fromStaticDataPepRisksReducer.getPepRisks
);
